import { useEffect, useState } from 'react';
import api from '@/lib/api';

export default function useLegalConfig() {
  const [config, setConfig] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  useEffect(() => {
    let active = true;
    api.get('/legal/config')
      .then((response) => {
        if (active) setConfig(response.data);
      })
      .catch(() => {
        if (active) setError(true);
      })
      .finally(() => {
        if (active) setLoading(false);
      });
    return () => { active = false; };
  }, []);

  return { config, loading, error };
}
